import axios from "axios";

function deduplicateValidCables(cables) {
  let cleanedCables = [];
  let cableMap = {};
  cables.forEach((cableObject) => {
    if (cableMap[cableObject.cable]) {
      cableMap[cableObject.cable].quantity += 1;
      cableMap[
        cableObject.cable
      ].customerInput += `, ${cableObject.customerInput}`;
      cableMap[
        cableObject.cable
      ].originalPayload += `, ${cableObject.originalPayload}`;
    } else {
      cableMap[cableObject.cable] = cableObject;
    }
  });
  for (let cable of Object.values(cableMap)) {
    cleanedCables.push(cable);
  }
  return cleanedCables;
}

export default {
  submitVinData: async ({ commit, state, rootState }, cableType) => {
    let productId = 53;

    if (
      rootState.activeProductKey === "VG-CBL" &&
      cableType &&
      cableType.includes("B")
    ) {
      productId = 24;
    } else if (cableType === "AG52") {
      productId = 125;
    }

    let response = await axios({
      method: "POST",
      url: "/webstore/submit-cables",
      headers: { "Content-type": "application/json" },
      data: {
        type: "vin",
        data: state.vinData
          .replaceAll(" ", "")
          .split("\n")
          .filter((vin) => vin)
          .map((vin) => {
            return { productId: productId, vin };
          }),
      },
    });
    if (response.status === 200) {
      let validCables = []
      const  errorCables = [];
      response.data.cableList.forEach((cable) => {
        cable.error ? errorCables.push(cable) : validCables.push(cable);
      });
      // Handling the case where API gives us back different objects with the same cale SKU
      // This has caused issues on Oppties where a different line item is created for each cable of the same sku
      validCables = deduplicateValidCables(validCables);
      
      const outOfStockCables = [];

      validCables = validCables.filter((cable) => {
        if (
          cable.cable in rootState.productCatalog?.CBL?.["AG-CBL"]?.offerings ||
          cable.cable in rootState.productCatalog?.CBL?.["VG-CBL"]?.offerings
        ) {
          return cable;
        } else {
          outOfStockCables.push(cable);
          return false;
        }
      });
      commit("setSubmittedVinData", validCables);
      return { errorCables, outOfStockCables };
    } else {
      throw "unhandledStatusCode";
    }
  },
};
